<!-- pages/auth/pending-approval/pending-approval.page.html -->

<div class="w-full min-h-screen bg-gray-50 flex items-center justify-center p-6">
  <div class="max-w-md w-full">
    <p-card>
      <div class="text-center">
        <!-- Icon -->
        <div class="mb-6">
          <div class="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center mx-auto">
            <i class="pi pi-clock text-4xl text-blue-600"></i>
          </div>
        </div>

        <!-- Title -->
        <h1 class="text-2xl font-semibold text-gray-900 mb-3">
          Warten auf Freigabe
        </h1>

        <!-- Message -->
        <p class="text-gray-600 mb-6">
          Hallo <strong>{{ userName }}</strong>,<br><br>
          Ihr Account wurde erfolgreich erstellt und wartet nun auf die Freigabe durch einen Administrator.
          Sie erhalten eine E-Mail, sobald Ihr Account freigeschaltet wurde.
        </p>

        <!-- Info Box -->
        <div class="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6 text-left">
          <div class="flex items-start gap-3">
            <i class="pi pi-info-circle text-blue-600 mt-1"></i>
            <div class="text-sm text-blue-800">
              <p class="font-medium mb-2">Was passiert als Nächstes?</p>
              <ul class="space-y-1 text-blue-700">
                <li>• Ein Administrator prüft Ihre Registrierung</li>
                <li>• Sie erhalten eine Benachrichtigung per E-Mail</li>
                <li>• Nach der Freigabe können Sie sich anmelden</li>
              </ul>
            </div>
          </div>
        </div>

        <!-- Actions -->
        <div class="flex flex-col gap-3">
          <p-button
            label="Status überprüfen"
            icon="pi pi-refresh"
            [loading]="isChecking"
            (onClick)="checkStatus()"
            styleClass="w-full">
          </p-button>
          
          <p-button
            label="Abmelden"
            icon="pi pi-sign-out"
            severity="secondary"
            (onClick)="logout()"
            styleClass="w-full">
          </p-button>
        </div>
      </div>
    </p-card>
  </div>
</div>